import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 获取本地运行时配置的动态数据, 比如调试工具提供的`tagline`, 自定义`accessToken`
 */
export type FabricGetRuntimeConfigCallbackData = {
  /**
   * 客户端调试工具模拟的并行环境tagline?, 对应APP需要去实现.
   * 注意并行环境的使用业务侧当下需要排除掉生产环境或者准生产环境, 避免生产日志干扰.
   */
  tagline?: string;
  /**
   * 客户端调试工具模拟的accessToken?, 对应APP需要去实现.
   */
  accessToken?: string;
};

/**
/**
 * 同步获取native开发包调试工具提供的一系列动态配置参数, 如tagline, accessToken等.
 * 此方法不会抛出异常, fallback到空对象.
 */
export const getRuntimeConfig = <
  T extends FabricGetRuntimeConfigCallbackData =
    FabricGetRuntimeConfigCallbackData,
>(): Partial<T> => {
  const result = core.call<'fabric_utils.getRuntimeConfig', T>(
    'fabric_utils.getRuntimeConfig'
  );
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    return {} as Partial<T>;
  } else {
    return result.data;
  }
};
